import Triagem from "@pages/Triagem/Triagem";

export default Triagem;
